// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1MpLs","rootSuccess":"CompleteLink_rootSuccess__3fkdf","rootFailure":"CompleteLink_rootFailure__2hRse","isDisabled":"CompleteLink_isDisabled__3fWOc"};